import { render, staticRenderFns } from "./SoftwareLicenseAgreement.vue?vue&type=template&id=38be18b6&"
import script from "./SoftwareLicenseAgreement.vue?vue&type=script&lang=js&"
export * from "./SoftwareLicenseAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports